import React from "react";
import MediaQuery from "react-responsive";
import { withRouteData } from "react-static";
import { withNamespaces } from "react-i18next";

import SmallMenu from "./small-screen-menu";
import LargeMenu from "./large-screen-menu";
import I18n from "../../i18n";
import "../../font-awesome/css/font-awesome.css";
import "./style.css";

const navbarStyle = {
  backgroundImage: "linear-gradient(#020A15, #011735)",
  margin: 0,
};

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuIsVisible: false,
    };

    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.setLanguage = this.setLanguage.bind(this);
  }

  hideMenu() {
    const mainNav = document.getElementById("menu");
    mainNav.classList.remove("active");
    this.setState({
      menuIsVisible: false,
    });
  }

  showMenu() {
    const mainNav = document.getElementById("menu");
    mainNav.classList.toggle("active");
    this.setState({
      menuIsVisible: true,
    });
  }

  setLanguage(lang) {
    const { pathname } = this.props.history.location;
    this.props.history.push(pathname + `?lang=${lang}`);
    I18n.changeLanguage(lang);
    this.hideMenu();
  }

  goTo = (path) => {
    this.props.history.push(path);
    this.hideMenu();
  };

  render() {
    const { menuIsVisible } = this.state;
    const { t, i18n, applyCustomStyle } = this.props;
    const { pathname } = this.props.history.location;
    const frURL = `${pathname}?lang=fr`;
    const enURL = `${pathname}?lang=en`;

    const lang = i18n.language;

    return (
      <div style={{ minHeight: "7vh" }}>
        <nav className="navbar" style={applyCustomStyle ? null : navbarStyle}>
          <span className="navbar-toggle" id="js-navbar-toggle">
            {menuIsVisible ? (
              <i className="fa fa-close" onClick={this.hideMenu} />
            ) : (
              <i className="fa fa-bars" onClick={this.showMenu} />
            )}
          </span>

          <a href="/" className="logo">
            <span>PharmaCam</span>
          </a>

          <MediaQuery query="screen and (max-width: 1000px)">
            <SmallMenu
              goTo={this.goTo}
              setLanguage={this.setLanguage}
              currentLang={lang}
              {...this.props}
            />
          </MediaQuery>

          <MediaQuery query="screen and (min-width: 1000px)">
            <LargeMenu
              goTo={this.goTo}
              setLanguage={this.setLanguage}
              currentLang={lang}
              {...this.props}
            />
          </MediaQuery>
        </nav>
      </div>
    );
  }
}

export default withNamespaces("translation")(withRouteData(NavBar));



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/components/navBar/index.js